import { Form, Input } from "antd";

import PropTypes from "prop-types";

const AddPlateNumber = ({ plateNumber, setPlateNumber, t, isDuplicatePlateNumber, setIsDuplicatePlateNumber }) => (
    <div>
        <p className="text-md font-medium mb-2">{t("plateNumber")}</p>
        <Form.Item
            validateStatus={isDuplicatePlateNumber ? "error" : ""}
            help={isDuplicatePlateNumber ? t("duplicatePlateError") : ""}>
            <Input
                placeholder={t("plateNumber")}
                value={plateNumber}
                onChange={(e) => {
                    const value = e.target.value.replace(/\s/g, ''); // Remove all spaces
                    setPlateNumber(value);
                    setIsDuplicatePlateNumber(false);
                }}
            />
        </Form.Item>
    </div>
);

AddPlateNumber.propTypes = {
    plateNumber: PropTypes.string.isRequired,
    setPlateNumber: PropTypes.func.isRequired,
    isDuplicatePlateNumber: PropTypes.bool.isRequired,
    setIsDuplicatePlateNumber: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default AddPlateNumber;
